(function () {
    var altmetric = {
        init: function () {
            altmetric.get.altmetric();
        },
        get: {
            altmetric: function () {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = window.location.protocol + '//d1bxh8uas1mnw7.cloudfront.net/assets/embed.js';
                document.getElementsByTagName('head')[0].appendChild(script);
            },
        },
    };

    UX.altmetric = altmetric;
})();
